(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name examination.directive:bfield
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="examination">
       <file name="index.html">
        <bfield></bfield>
       </file>
     </example>
   *
   */
  angular
    .module('examination')
    .directive('bfield', bfield);

  bfield.$inject = ['$log', '$rootScope'];

  function bfield($log, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        efield: '=',
        bvalues: '=',
        ti: '@?'
      },
      templateUrl: 'examination/exameditor-bfield.tpl.html',
      replace: false,
      controllerAs: 'bfCtrl',
      bindToController: true,
      controller: function ($scope) {
        var vm = this;
        vm.loadBValues = loadBValues;
        vm.save = save;


        vm.tabi = parseInt(vm.ti, 10);
        vm.fti = 1000 + vm.tabi;

        function save() {
          $log.debug('bfield save called');
          $scope.$emit('tagadded', '');
          // $rootScope.$broadcast('tagadded', '');

        }
        
        function loadBValues($query) {
          var promise = new Promise(function (resolve, reject) {
            // TODO this is a rather nasty piece of code to generate a promise that is needed in the next step
            if (true) {
              // console.log('bfield values', vm.bvalues);
              resolve(vm.bvalues);
            }
            else {
              reject([]);
            }
          });
          return promise.then(function (values) {
            var filteredValues = values.filter(function (value) {
              return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
            });
            // console.log('filtered values: ', filteredValues);
            return filteredValues;
          });
        }
      }
    };
  }
}());
